














import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "RationaleSelect",
  props: {
    value: { type: Array, default: null }
  },
  setup(props, context) {
    const proxy = computed({
      get: () => props.value,
      set: value => context.emit("input", value)
    });

    return { proxy };
  }
});
